import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { NavMenu } from './NavMenu';
import { Header } from './Header';
import { Footer } from './Footer';
import * as State from '../service/AppState';
import * as Session from '../service/Session';
import * as API from '../service/apisvc';
import * as TF from '../service/tradeflow';
import * as DTO from '../service/DTOs';
import * as Intl from 'react-intl'
import ru from 'react-intl/locale-data/ru';
import en from 'react-intl/locale-data/en';
import { ReactElement } from 'react';
import { withRouter } from "react-router-dom"
//import { History } from 'history';


export interface LayoutProps {
    children?: React.ReactNode;
    history: History;
    location: Location;
    //    appstate: State.AppState;
};


//& RouteComponentProps<{}>
export class Layout extends React.Component<LayoutProps, State.AppState> {
    _t_counter: number;
    _t_fresh_counter_back: number;
    _t_new_text_messages_back: number;
    timerID: any;
    _redirect: string | undefined;
    _redirectPerm: string | undefined;

    constructor(props: LayoutProps) {
        super(props);
        //this.state = { ...initialState, ...props };
        this._t_counter = 0;
        this.state = { ...State.default, ...this.masterStateRestore(), ...{ connection: { status: 'reconnecting' } } };
        this._t_fresh_counter_back = 0;
        this._t_new_text_messages_back = 0;
        this._redirect = undefined;
        this._redirectPerm = this.state.user ? State.routeServerAction(this.state.user.identityState.identAction) : undefined;

        Intl.addLocaleData([...en, ...ru]);

        this.processChatActivity = this.processChatActivity.bind(this);
    }

    tick() {
        this._t_counter = this._t_counter + 1;
        if (this._t_counter > 10) {
            this.setState({ connection: { status: 'disconnected', time: new Date() } });
        }
        else if (this._t_counter > 4) {
            this.setState({ connection: { status: 'reconnecting', time: new Date() } });
        }
        else {
            this.setState({ connection: { status: 'connected', time: new Date() } });
        }

        if (this._t_fresh_counter_back > 0) {
            this._t_fresh_counter_back = this._t_fresh_counter_back - 1;

            if (this._t_fresh_counter_back == 0) {
                // fire
                TF.PublishCommandForceAgentFrame();
            }
        }

        if (this._t_new_text_messages_back > 0) {
            this._t_new_text_messages_back = this._t_new_text_messages_back - 1;

            if (this._t_new_text_messages_back == 0) {
                // fire
                //TF.PublishCommandForceAgentFrame();
            }
        }

    }

    masterStateRestore() {
        let _user = Session.currentUser();
        if (_user)
            return { user: _user };
        else
            return { user: { identityState: Session.AnonimousIdentityState } };
    }

    processHubSts(hubstatus: 'disconnected' | 'connected' | 'slow' | 'reconnecting') {
        //console.log('processHubSts');
        //console.log(hubstatus);

        this.setState({ connection: { status: hubstatus, time: new Date() } });
        this._t_counter = hubstatus == 'disconnected' ? 10 : (hubstatus == 'reconnecting' ? 4 : 0);

        if (hubstatus == 'connected')
            TF.PublishCommandForceAgentFrame();

        return {};
    }

    processChangeUser(cmd: TF.ContextCommand) {
        let _user = this.masterStateRestore();
        //this.setState(function (state, props) {
        //    return this.masterStateRestore();
        //});
        this.setState({ ...this.state, ..._user });

        this._redirectPerm = this.state.user ? State.routeServerAction(this.state.user.identityState.identAction) : undefined;

        TF.PublishCommandForceAgentContext();

        return {};
    }

    dismissToast() {

    }

    processLoginRevalidate(cmd: TF.SystemCommand) {
        //console.log('processLoginRevalidate');
        Session.accountActions.logout(() => { return this.state; }, (action: Session.LoginAction) => { return {} });
        this._redirect = '/login';

        //let _user = this.masterStateRestore();
        //this.setState({ ...this.state, ..._user });
        return {};
    }


    processUserInteractionCtx(payload: DTO.UserInteractionContext) {
        //console.log('processUserInteractionCtx');
        //console.log(cmd);
        if (this.refs.cmpAppRootRef) {
            this.setState({ ...this.state, ...{ uiContext: payload } });
        }
        return {};
    }

    processNewMessagesRead() {
        if (this.refs.cmpAppRootRef) {
            this.setState({ tmessages: [] });
        }

        return {};
    }

    processAgentDSPeriodFilterMyDeals(filter: DTO.AgentDSPeriodFilter) {
        let filter_prev = this.state.dsctx.myDealsDS.periodFilter;
        filter_prev.finishDateIncl = filter.finishDateIncl;
        filter_prev.startDateIncl = filter.startDateIncl;
        filter_prev.isCurrentPeriod = filter.isCurrentPeriod;

        this.forceUpdate();

        TF.PublishCommandForceAgentFrame();

        return {};
    }

    processAgentDSAttributesFilterMyDeals(filter: DTO.AgentDSAttributesFilter) {
        let filter_prev = this.state.dsctx.myDealsDS.attributesFilter;
        filter_prev.isMyOwnOnly = filter.isMyOwnOnly;

        this.forceUpdate();

        TF.PublishCommandForceAgentFrame();

        return {};
    }

    processAgentDSPeriodFilterMyOrders(filter: DTO.AgentDSPeriodFilter) {
        let filter_prev = this.state.dsctx.myOrdersDS.periodFilter;
        filter_prev.finishDateIncl = filter.finishDateIncl;
        filter_prev.startDateIncl = filter.startDateIncl;
        filter_prev.isCurrentPeriod = filter.isCurrentPeriod;

        //this.setState(prevState => ({
        //    ...prevState,
        //    dsctx: {
        //        ...prevState.dsctx,
        //        myOrdersDS: {
        //            ...prevState.dsctx.myOrdersDS,
        //            periodFilter: {
        //                ...prevState.dsctx.myOrdersDS.periodFilter,
        //                filter
        //            }
        //        }
        //    }
        //}));

        //console.log('processAgentDSPeriodFilterMyOrders');
        //console.log(filter);


        this.forceUpdate();

        TF.PublishCommandForceAgentFrame();

        return {};
    }

    processAgentDSAttributesFilterMyOrders(filter: DTO.AgentDSAttributesFilter) {
        let filter_prev = this.state.dsctx.myOrdersDS.attributesFilter;
        filter_prev.isMyOwnOnly = filter.isMyOwnOnly;

        //console.log('processAgentDSAttributesFilterMyOrders');
        //console.log(filter_prev);

        this.forceUpdate();

        TF.PublishCommandForceAgentFrame();

        return {};
    }

    processAgentDSInstrumentFilter(data: DTO.AgentDSInstrumentFilter) {
        //console.log('processAgentDSInstrumentFilter');
        let ifilters = this.state.dsctx.instrumentsDS.instruments;

        for (var i in ifilters) {
            if (ifilters[i].fiid == data.fiid) {
                ifilters[i].isContragentLimits = data.isContragentLimits;
                ifilters[i].isSecuritiesFilters = data.isSecuritiesFilters;
                break;
            }
        }

        this.forceUpdate();

        //if (this.refs.cmpAppRootRef) {
        //this.forceUpdate();
        //console.log('processAgentDSInstrumentFilter setState');

        //this.setState(prevState => ({
        //    ...prevState,
        //    dsctx: {
        //        ...prevState.dsctx,
        //        instrumentsDS: {
        //            ...prevState.dsctx.instrumentsDS,
        //            instruments: {
        //                ...prevState.dsctx.instrumentsDS.instruments,
        //                ifilters
        //            }
        //        }
        //    }
        //}));
        //}

        TF.PublishCommandForceAgentFrame();

        return {};
    }

    processHeartbeat(data: DTO.SystemHeader) {
        this._t_counter = 0;
        if (this.refs.cmpAppRootRef) {
            this.setState({
                syshdr: data
            });
        }

        return { return: 0 };
    }

    processSysAvail(data: DTO.SystemOperationAvailabilityDto) {
        this._t_counter = 0;
        if (this.refs.cmpAppRootRef) {
            this.setState({
                sysavail: data
            });
        }

        return { return: 0 };
    }

    processFreshData(data: DTO.SystemHeader) {
        //console.log('processFreshData');
        if (this.refs.cmpAppRootRef) {
            if (this._t_fresh_counter_back > 0 && this._t_fresh_counter_back <= 3) {
                TF.PublishCommandForceAgentFrame();
            }
            this._t_fresh_counter_back = 5;
        }

        return { return: 0 };
    }


    processChatActivity(data: DTO.AgentChatActivity[]) {
        if (this.refs.cmpAppRootRef) {
            //console.log('processChatActivity');
            data.map(a => {
                let usr = this.state.user ? this.state.user : null;
                if (usr && usr.personalState) {
                    if (a.idperson == usr.personalState.idperson) {
                        const restmsgs = this.state.tmessages.filter(x => x.idchat != a.idchat || x.messagetime > a.lastread);
                        this.setState({ tmessages: restmsgs });
                    }

                    const _chatact: DTO.AgentChatActivity[] = Object.assign([] as DTO.AgentChatActivity[], this.state.chatactivity);
                    //const _chatact = this.state.chatactivity.map
                    let idx = this.state.chatactivity.findIndex(x => x.idchat == a.idchat && x.idperson == a.idperson);
                    if (idx >= 0)
                        _chatact[idx] = a;
                    else
                        _chatact.push(a);

                    this.setState({ chatactivity: _chatact });

                    //TF.PublishCommandForceAgentFrame();
                }

            });
        }

        return { return: 0 };
    }

    processNewTextMessage(data: DTO.AgentTextMessage) {
        if (this.refs.cmpAppRootRef) {
            this.state.tmessages.push(data);

            this.forceUpdate();

            this._t_new_text_messages_back = 5;
        }

        return { return: 0 };
    }

    processUpdateConfig(cfg: DTO.AppConfig) {
        this.setState({ appId: cfg.idapp, sharedChatId: cfg.sharedchatid, appFamily: cfg.appFamily });
        return {};
    }


    processMarketQuotes(data: DTO.MarketQuotes) {
        //console.log('processMarketQuotes');
        //console.log(data);

        this.setState({ marketquotes: data });


        return { return: 0 };
    }


    componentDidMount() {
        TF.CommandProcessBinding(this, { type: 'COMMAND.changeuser', delegate: this.processChangeUser });
        TF.CommandProcessBinding(this, { type: 'COMMAND.loginrevalidate', delegate: this.processLoginRevalidate });

        TF.CommandProcessBinding(this, { type: 'COMMAND.UI.UserInteractionCtx', delegate: this.processUserInteractionCtx });
        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSInstrumentFilter', delegate: this.processAgentDSInstrumentFilter });
        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyOrders', delegate: this.processAgentDSPeriodFilterMyOrders });
        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSAttributesFilterMyOrders', delegate: this.processAgentDSAttributesFilterMyOrders });

        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyDeals', delegate: this.processAgentDSPeriodFilterMyDeals });
        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSAttributesFilterMyDeals', delegate: this.processAgentDSAttributesFilterMyDeals });

        TF.CommandProcessBinding(this, { type: 'COMMAND.State.NewMessagesRead', delegate: this.processNewMessagesRead });

        TF.CommandProcessBinding(this, { type: 'HUB.status', delegate: this.processHubSts });

        TF.DataProcessBinding(this, { type: 'SYS.heartbeat', delegate: this.processHeartbeat });
        TF.DataProcessBinding(this, { type: 'SYS.updatesysavail', delegate: this.processSysAvail });
        TF.DataProcessBinding(this, { type: 'SYS.freshchanges', delegate: this.processFreshData });

        TF.DataProcessBinding(this, { type: 'SYS.MSG.newmessage', delegate: this.processNewTextMessage });
        TF.DataProcessBinding(this, { type: 'SYS.MSG.chatactivity', delegate: this.processChatActivity });

        TF.DataProcessBinding(this, { type: 'SYS.MSG.marketquotes', delegate: this.processMarketQuotes });



        TF.CommandProcessBinding(this, { type: 'COMMAND.SYS.UpdateConfig', delegate: this.processUpdateConfig });



        TF.registerAuthHeaderExchange();
        TF.registerDataSliceExchange(() => {
            //console.log('DataSliceExchange');
            //console.log(this.state.dsctx);
            return this.state.dsctx;
        });

        this._t_counter = 0;
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );

        TF.PublishCommandForceAgentFrame();
    }

    componentWillUnmount() {
        if (this.timerID)
            clearInterval(this.timerID);


        TF.CommandProcessUnBinding(this, { type: 'COMMAND.changeuser', delegate: this.processChangeUser });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.loginrevalidate', delegate: this.processLoginRevalidate });

        TF.CommandProcessUnBinding(this, { type: 'COMMAND.UI.UserInteractionCtx', delegate: this.processUserInteractionCtx });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.AgentDSInstrumentFilter', delegate: this.processAgentDSInstrumentFilter });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyOrders', delegate: this.processAgentDSPeriodFilterMyOrders });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.AgentDSAttributesFilterMyOrders', delegate: this.processAgentDSAttributesFilterMyOrders });

        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyDeals', delegate: this.processAgentDSPeriodFilterMyDeals });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.AgentDSAttributesFilterMyDeals', delegate: this.processAgentDSAttributesFilterMyDeals });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.State.NewMessagesRead', delegate: this.processNewMessagesRead });
        TF.CommandProcessUnBinding(this, { type: 'HUB.status', delegate: this.processHubSts });

        TF.DataProcessUnBinding(this, { type: 'SYS.heartbeat', delegate: this.processHeartbeat });
        TF.DataProcessUnBinding(this, { type: 'SYS.updatesysavail', delegate: this.processSysAvail });
        TF.DataProcessUnBinding(this, { type: 'SYS.freshchanges', delegate: this.processFreshData });

        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.newmessage', delegate: this.processNewTextMessage });
        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.chatactivity', delegate: this.processChatActivity });

        TF.DataProcessUnBinding(this, { type: 'SYS.MSG.marketquotes', delegate: this.processMarketQuotes });



        TF.CommandProcessUnBinding(this, { type: 'COMMAND.SYS.UpdateConfig', delegate: this.processUpdateConfig });

    }

    renderIncompatibleBrowser(compat: State.BrowserCompatibility) {
        return <div className='container-fluid' ref="cmpAppRootRef">
            <div className='row'>
                <h4>Работа в браузере '{compat.browser}' в настоящее время не поддерживается</h4>
                <br />
                <h4>Work in '{compat.browser}' browser is not supported currently</h4>
                <br />
                User Agent is: {navigator.userAgent}
            </div>
        </div>
    }

    //<div className='row' style={{ marginTop: '60px' }}>
    public render() {
        if (this._redirect) {
            let url = this._redirect;
            this._redirect = undefined;
            return <Redirect to={url} />;
        }

        if (this._redirectPerm && this._redirectPerm != this.props.location.pathname) {

            if (this.props.location.pathname != '/logout' && this.props.location.pathname != '/help' && this.props.location.pathname != '/profile') {
                let urlp = this._redirectPerm;
                return <Redirect to={urlp} />;
            }
        }



        let broCompat = State.browserCompat();

        //const { children } = this.props;

        //const childrenWithProps = React.Children.map(children, child =>
        //    React.cloneElement(child, { appstate: this.state}));

        //{ this.props.children ? React.cloneElement(this.props.children as ReactElement<any>, { appstate: this.state }) : undefined }        

        //let child: React.ReactNode = this.props.children;
        //let childWProps = React.cloneElement(child as ReactElement<any>, { updateConfigState: this.updateConfigState });

        if (broCompat.compatibility)
            return <Intl.IntlProvider locale="ru">
                <div className='container-fluid' ref="cmpAppRootRef">
                    <div className='row'>
                        <NavMenu {...this.state} user={this.state.user ? this.state.user : { identityState: Session.AnonimousIdentityState }} appFamily={this.state.appFamily} />
                    </div>
                    <div className='row'>
                        <div className='col-sm-12' style={{ marginBottom: '50px' }}>
                            {this.props.children}
                        </div>
                    </div>
                    <div className="row" id="footer">
                        <Footer connection={this.state.connection} syshdr={this.state.syshdr} tradesession={this.state.sysavail.tradesession} toasts={[]} onDismissToast={this.dismissToast} appState={this.state} />
                    </div>
                </div>
            </Intl.IntlProvider>;
        else
            return this.renderIncompatibleBrowser(broCompat);
    }
}











//import * as React from 'react';
//import { Redirect } from 'react-router-dom';

//import { NavMenu } from './NavMenu';
//import { Header } from './Header';
//import { Footer } from './Footer';
//import * as State from '../service/AppState';
//import * as Session from '../service/Session';
//import * as API from '../service/apisvc';
//import * as TF from '../service/tradeflow';
//import * as DTO from '../service/DTOs';
//import * as Intl from 'react-intl'
//import { ReactElement } from 'react';
//import { withRouter } from "react-router-dom"
////import { History } from 'history';


//export interface LayoutProps {
//    children?: React.ReactNode;
//    history: History;
//    location: Location;
////    appstate: State.AppState;
//};


////& RouteComponentProps<{}>
//export class Layout extends React.Component<LayoutProps , State.AppState> {
//    _t_counter: number;
//    _t_fresh_counter_back: number;
//    _t_new_text_messages_back: number;
//    timerID: any;
//    _redirect: string | undefined;
//    _redirectPerm: string | undefined; 

//    constructor(props: LayoutProps) {
//        super(props);
//        //this.state = { ...initialState, ...props };
//        this.state = { ...State.default, ...this.masterStateRestore(), ...{ connection: { status: 'reconnecting' } } };
//        this._t_fresh_counter_back = 0;
//        this._t_new_text_messages_back = 0;
//        this._redirect = undefined;
//        this._redirectPerm = this.state.user ? State.routeServerAction(this.state.user.identityState.identAction) : undefined;
//    }    

//    tick() {
//        this._t_counter = this._t_counter + 1;
//        if (this._t_counter > 10) {
//            this.setState({ connection: { status: 'disconnected', time: new Date() } });
//        }
//        else if (this._t_counter > 4) {
//            this.setState({ connection: { status: 'reconnecting', time: new Date() } });
//        }
//        else {
//            this.setState({ connection: { status: 'connected', time: new Date() } });
//        }

//        if (this._t_fresh_counter_back > 0) {
//            this._t_fresh_counter_back = this._t_fresh_counter_back - 1;

//            if (this._t_fresh_counter_back == 0) {
//                // fire
//                TF.PublishCommandForceAgentFrame();
//            }
//        }

//        if (this._t_new_text_messages_back > 0) {
//            this._t_new_text_messages_back = this._t_new_text_messages_back - 1;

//            if (this._t_new_text_messages_back == 0) {
//                // fire
//                //TF.PublishCommandForceAgentFrame();
//            }
//        }
        
//    }

//    masterStateRestore() {
//        let _user = API.currentUser();
//        if (_user)
//            return { user: _user };
//        else 
//            return { user: { identityState: Session.AnonimousIdentityState } };
//    }

//    processHubSts(hubstatus: 'disconnected' | 'connected' | 'slow' | 'reconnecting') {
//        //console.log('processHubSts');
//        //console.log(hubstatus);

//        this.setState({ connection: { status: hubstatus, time: new Date() } });
//        return {};
//    }

//    processChangeUser(cmd: TF.ContextCommand) {
//        let _user = this.masterStateRestore();
//        //this.setState(function (state, props) {
//        //    return this.masterStateRestore();
//        //});
//        this.setState({ ...this.state, ..._user });

//        this._redirectPerm = this.state.user ? State.routeServerAction(this.state.user.identityState.identAction) : undefined;

//        TF.PublishCommandForceAgentContext();

//        return {};
//    }

    
//    processLoginRevalidate(cmd: TF.SystemCommand) {
//        console.log('processLoginRevalidate');
//        Session.accountActions.logout(() => { return this.state; }, (action: Session.LoginAction) => { return {} });
//        this._redirect = '/login';

//        //let _user = this.masterStateRestore();
//        //this.setState({ ...this.state, ..._user });
//        return {};
//    }


//    processUserInteractionCtx(cmd: TF.UserInteractionCommand) {
//        //console.log('processUserInteractionCtx');
//        //console.log(cmd);
//        if (this.refs.cmpAppRootRef) {
//            this.setState({ ...this.state, ...{ uiContext: cmd.payload } });
//        }
//        return {};
//    }

//    processNewMessagesRead() {
//        if (this.refs.cmpAppRootRef) {
//            this.setState({ tmessages: [] });
//        }

//        return {};
//    }

//    processAgentDSPeriodFilterMyDeals(filter: DTO.AgentDSPeriodFilter) {
//        let filter_prev = this.state.dsctx.myDealsDS.periodFilter;
//        filter_prev.finishDateIncl = filter.finishDateIncl;
//        filter_prev.startDateIncl = filter.startDateIncl;
//        filter_prev.isCurrentPeriod = filter.isCurrentPeriod;

//        this.forceUpdate();

//        TF.PublishCommandForceAgentFrame();

//        return {};
//    }

//    processAgentDSPeriodFilterMyOrders(filter: DTO.AgentDSPeriodFilter) {
//        let filter_prev = this.state.dsctx.myOrdersDS.periodFilter;
//        filter_prev.finishDateIncl = filter.finishDateIncl;
//        filter_prev.startDateIncl = filter.startDateIncl;
//        filter_prev.isCurrentPeriod = filter.isCurrentPeriod;

//        //this.setState(prevState => ({
//        //    ...prevState,
//        //    dsctx: {
//        //        ...prevState.dsctx,
//        //        myOrdersDS: {
//        //            ...prevState.dsctx.myOrdersDS,
//        //            periodFilter: {
//        //                ...prevState.dsctx.myOrdersDS.periodFilter,
//        //                filter
//        //            }
//        //        }
//        //    }
//        //}));

//        //console.log('processAgentDSPeriodFilterMyOrders');
//        //console.log(filter);
        

//        this.forceUpdate();

//        TF.PublishCommandForceAgentFrame();

//        return {};
//    }


//    processAgentDSInstrumentFilter(data: DTO.AgentDSInstrumentFilter) {
//        //console.log('processAgentDSInstrumentFilter');
//        let ifilters = this.state.dsctx.instrumentsDS.instruments;

//        for (var i in ifilters) {
//            if (ifilters[i].fiid == data.fiid) {
//                ifilters[i].isContragentLimits = data.isContragentLimits;
//                ifilters[i].isSecuritiesFilters = data.isSecuritiesFilters;
//                break;
//            }
//        }

//        this.forceUpdate();

//        //if (this.refs.cmpAppRootRef) {
//            //this.forceUpdate();
//            //console.log('processAgentDSInstrumentFilter setState');

//            //this.setState(prevState => ({
//            //    ...prevState,
//            //    dsctx: {
//            //        ...prevState.dsctx,
//            //        instrumentsDS: {
//            //            ...prevState.dsctx.instrumentsDS,
//            //            instruments: {
//            //                ...prevState.dsctx.instrumentsDS.instruments,
//            //                ifilters
//            //            }
//            //        }
//            //    }
//            //}));
//        //}

//        TF.PublishCommandForceAgentFrame();

//        return {};
//    }

//    processHeartbeat(data: DTO.SystemHeader) {
//        this._t_counter = 0;
//        if (this.refs.cmpAppRootRef) {
//            this.setState({
//                syshdr: data
//            });
//        }

//        return { return: 0 };
//    }

//    processSysAvail(data: DTO.SystemOperationAvailabilityDto) {
//        this._t_counter = 0;
//        if (this.refs.cmpAppRootRef) {
//            this.setState({
//                sysavail: data
//            });
//        }

//        return { return: 0 };
//    }

//    processFreshData(data: DTO.SystemHeader) {
//        //console.log('processFreshData');
//        if (this.refs.cmpAppRootRef) {
//            if (this._t_fresh_counter_back > 0 && this._t_fresh_counter_back <=3) {
//                TF.PublishCommandForceAgentFrame();
//            }
//            this._t_fresh_counter_back = 5;
//        }

//        return { return: 0 };
//    }

//    processNewTextMessage(data: DTO.AgentTextMessage) {
//        if (this.refs.cmpAppRootRef) {
//            this.state.tmessages.push(data);

//            this.forceUpdate();

//            this._t_new_text_messages_back = 5;
//        }

//        return { return: 0 };
//    }

//    componentDidMount() {
//        TF.CommandProcessBinding(this, { type: 'COMMAND.changeuser', delegate: this.processChangeUser });
//        TF.CommandProcessBinding(this, { type: 'COMMAND.loginrevalidate', delegate: this.processLoginRevalidate });
        
//        TF.CommandProcessBinding(this, { type: 'COMMAND.UI.UserInteractionCtx', delegate: this.processUserInteractionCtx });
//        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSInstrumentFilter', delegate: this.processAgentDSInstrumentFilter });
//        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyOrders', delegate: this.processAgentDSPeriodFilterMyOrders });
//        TF.CommandProcessBinding(this, { type: 'COMMAND.State.AgentDSPeriodFilterMyDeals', delegate: this.processAgentDSPeriodFilterMyDeals });
//        TF.CommandProcessBinding(this, { type: 'COMMAND.State.NewMessagesRead', delegate: this.processNewMessagesRead });        
        
//        TF.CommandProcessBinding(this, { type: 'HUB.status', delegate: this.processHubSts });
        
//        TF.DataProcessBinding(this, { type: 'SYS.heartbeat', delegate: this.processHeartbeat });
//        TF.DataProcessBinding(this, { type: 'SYS.updatesysavail', delegate: this.processSysAvail });
//        TF.DataProcessBinding(this, { type: 'SYS.freshchanges', delegate: this.processFreshData });
        
//        TF.DataProcessBinding(this, { type: 'SYS.MSG.newmessage', delegate: this.processNewTextMessage });
        
        

//        TF.registerAuthHeaderExchange();
//        TF.registerDataSliceExchange(() => {
//            //console.log('DataSliceExchange');
//            //console.log(this.state.dsctx);
//            return this.state.dsctx;
//        });

//        this._t_counter = 0;
//        this.timerID = setInterval(
//            () => this.tick(),
//            1000
//        );
//    }

//    componentWillUnmount() {
//        if (this.timerID)
//            clearInterval(this.timerID);
//    }

//    renderIncompatibleBrowser(compat: State.BrowserCompatibility) {
//        return <div className='container-fluid' ref="cmpAppRootRef">
//            <div className='row'>
//                <h4>Работа в браузере '{compat.browser}' в настоящее время не поддерживается</h4>
//                <br />
//                <h4>Work in '{compat.browser}' browser is not supported currently</h4>
//                <br/>
//                User Agent is: {navigator.userAgent}
//                </div>
//            </div>
//    }

//    //<div className='row' style={{ marginTop: '60px' }}>
//    public render() {
//        if (this._redirect) {
//            let url = this._redirect;
//            this._redirect = undefined;
//            return <Redirect to={url} />;
//        }
        
//        if (this._redirectPerm && this._redirectPerm != this.props.location.pathname) {
            
//            if (this.props.location.pathname != '/logout' && this.props.location.pathname != '/help' && this.props.location.pathname != '/profile') {
//                let urlp = this._redirectPerm;
//                return <Redirect to={urlp} />;
//            }
//        }
        
        

//        let broCompat = State.browserCompat();

//        //const { children } = this.props;

//        //const childrenWithProps = React.Children.map(children, child =>
//        //    React.cloneElement(child, { appstate: this.state}));

//        //{ this.props.children ? React.cloneElement(this.props.children as ReactElement<any>, { appstate: this.state }) : undefined }

//        if (broCompat.compatibility)
//            return <Intl.IntlProvider locale="en">
//                <div className='container-fluid' ref="cmpAppRootRef">
//                    <div className='row'>
//                        <NavMenu user={this.state.user ? this.state.user : { identityState: Session.AnonimousIdentityState }} syshdr={this.state.syshdr} tmessages={this.state.tmessages} />
//                    </div>
//                    <div className='row'>
//                        <div className='col-sm-12' style={{ marginBottom: '50px' }}>
//                            {this.props.children}
//                        </div>
//                    </div>
//                    <div className="row" id="footer">
//                        <Footer connection={this.state.connection} syshdr={this.state.syshdr} tradesession={this.state.sysavail.tradesession} />
//                    </div>
//                </div>
//            </Intl.IntlProvider>;
//        else
//            return this.renderIncompatibleBrowser(broCompat);
//    }
//}
